import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";
import { AgentLogo } from "./AgentLogo";

/**
 * Marks something KBo created on the user's behalf.
 */
export function KboGeneratedBadge() {
    return (
        <Tooltip title="Created with KBo">
            <Box
                component="span"
                aria-label="Created with KBo"
                sx={{
                    alignItems: "center",
                    display: "inline-flex",
                    flexShrink: 0,
                    gap: 0.5,
                }}
            >
                <AgentLogo gradient height="14px" width="14px" />
                <Typography
                    component="span"
                    sx={(theme) => ({
                        color: theme.palette.primary[600],
                        fontSize: 11,
                        fontWeight: 700,
                        letterSpacing: "0.12em",
                    })}
                >
                    KBo
                </Typography>
            </Box>
        </Tooltip>
    );
}
